import CountNumber from '@/Components/CountNumber';
import React, { useEffect, useRef, useState } from 'react'
import { useTranslation } from 'react-i18next';
interface Posibility {
    id: number;
    name: string;
    number: number;
    image: string;
}

interface Props {
    posibility: Posibility[]
}
export default function Possibilty({ posibility }: Props) {
    const { t, i18n } = useTranslation();
    return (
        <>


            <div className="p-4 flex flex-col">
                <div className='flex'>

                    <p className=' text-custom-dark-blue font-bold text-sm lg:text-base p-4 dark:text-white'>
                        {t('possibil.title')}
                    </p>
                </div>
                <p className='dark:text-white font-bold text-sm lg:text-sm p-4 pt-1 font-sans'>
                    {t('possibil.subtitle')}
                </p>
                <div className='relative group overflow-hidden'>

                    {/* <div className={`absolute inset-y-0 ${i18n.language === 'ar' ? 'right-0' : 'left-0'}  w-0 bg-yellow-400 rounded-full transition-all duration-300 ease-in-out group-hover:w-full z-0`}></div> */}

                </div>

            </div>

            <div className='m-5 p-5 flex  justify-evenly items-center flex-col lg:flex-row gap-4'>
                {posibility.map((possibil: any) =>
                    <div
                        // ref={fadeUpRef}
                        key={possibil.id}
                        className={`flex lg:justify-between lg:items-center lg:w-auto w-full  gap-4`}>
                        <div className='flex justify-between lg:w-auto w-full ease-out hover:-translate-y-2 transition-all group'>
                            {
                                i18n.language === 'en' && (<img src={possibil.image} alt="" className='h-16 group-hover:rotate-[360deg] group-hover:scale-125  group-hover:px-2 duration-700 ' />)
                            }

                            <div className='hover:text-custom-sky-blue'>
                                <div className='flex gap-2 items-center lg:text-base text-sm'>
                                    {
                                        i18n.language === 'en' && (<span className='lg:text-base text-sm font-bold text-custom-sky-blue'>+</span>)
                                    }
                                    <CountNumber number={possibil.number} />
                                    {
                                        i18n.language === 'ar' && (<span className='lg:text-base text-sm font-bold text-custom-sky-blue'>+</span>)
                                    }
                                </div>
                                <p
                                className="group hover:text-custom-sky-blue font-sans lg:text-base text-sm text-custom-sky-blue font-bold dark:text-white"
                                >{possibil.name}</p>
                            </div>
                            {
                                i18n.language === 'ar' && (<img src={possibil.image} alt="" className='h-16 group-hover:rotate-[360deg] group-hover:scale-125  group-hover:px-2 duration-700 ' />)
                            }

                        </div>
                    </div>

                )}
            </div>
        </>
    )
}
